import type { FC } from 'react';
import React, { Fragment } from 'react';

import { LoadableAfterPaint, LoadableHydrateOnHover } from '@confluence/loadable';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';
import {
	checkSSRPartialSuccess,
	SSR_PARTIAL_COMPONENT,
} from '@confluence/ssr-utilities/entry-points/ssrPartialSuccess';

import type { PageTreeProps } from '../src/PageTree';
import { expVal } from '@confluence/feature-experiments';

const DELAY_HYRATION_ON_HOVER_FF = 'confluence_frontend_delay_hydration_on_hover';

export const ANIMATE_TIME_SEC = 2;

export const PageTreeLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PageTree" */ '../src/PageTree')).PageTree,
});

export const PageTreeLoaderOnHover = LoadableHydrateOnHover({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PageTreeOnHover" */ '../src/PageTree')).PageTree,
	hydrateImmediately: () => {
		// If page tree was not successfully rendered on server-side, hydrate immediately otherwise user will see a blank page tree
		return !checkSSRPartialSuccess(SSR_PARTIAL_COMPONENT.PageTree);
	},
});

export const PageTree: FC<PageTreeProps> = (props) => {
	const delayHydrationOnHoverTimeout =
		StatsigConfigurations.getNumber(DELAY_HYRATION_ON_HOVER_FF, 0) || 0;
	return (
		<Fragment>
			{!expVal('confluence_frontend_remove_hydrateonhover_pagetree', 'isEnabled', false) &&
			delayHydrationOnHoverTimeout > 0 ? (
				<PageTreeLoaderOnHover {...props} />
			) : (
				<PageTreeLoader {...props} />
			)}
		</Fragment>
	);
};
